export default values => {
  const linkingErrors = []

  const linkedTypes = values.entities?.filter(e => e.id).map(e => e.type) || []

  const hasSome = (...types) => types.some(t => linkedTypes.includes(t))
  const hasEvery = (...types) => types.every(t => linkedTypes.includes(t))
  const hasOnly = (...types) => linkedTypes.every(t => types.includes(t))
  // const hasNone = (...types) => !linkedTypes.some(t => types.includes(t))

  switch (values.type) {
    case 'vulnerable_customer':
      if (!hasEvery('consumers') || !hasOnly('consumers')) {
        linkingErrors.push(
          'This type of ticket should only be linked to a Consumer.'
        )
      }
      break
    case 'complaint':
      if (!hasSome('consumers', 'merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to at least a Merchant or Consumer.'
        )
      }
      if (!hasSome('offers', 'leads', 'bills', 'plans')) {
        linkingErrors.push(
          'This type of ticket should be linked to at least a Transaction, Lead, Bill or Subscription.'
        )
      }
      break
    case 'refund_request':
      if (!hasSome('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      if (!hasSome('offers', 'leads', 'bills', 'plans')) {
        linkingErrors.push(
          'This type of ticket should be linked to Transaction, Bill or Subscription.'
        )
      }
      break
    case 'covid_19_freeze_request':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      if (!hasSome('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'pre_arrears':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      if (!hasSome('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'arrears_0_14':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      if (!hasSome('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case '30_day_breathing_space':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      if (!hasSome('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'payment_freeze':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      if (!hasSome('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'reduced_payment_plan':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      if (!hasSome('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'adhoc_payment_plan':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      if (!hasSome('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'iva':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      break
    case 'dissatisfaction':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      break
    case 'financial_ombudsman':
      if (!hasSome('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      break
    case 'bankruptcy':
      if (!hasEvery('consumers', 'offers')) {
        linkingErrors.push(
          'This type of ticket must be attached to a consumer and at least 1 offer'
        )
      }
      break
    case 'finance_manual_review':
      if (!hasEvery('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'merchant_manual_review':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break
    case 'merchant_quarterly_call':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break
    case 'finance_review_document':
      if (!hasEvery('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'finance_follow_up':
      if (!hasEvery('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break
    case 'deceased':
      if (!hasEvery('consumers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Consumer.'
        )
      }
      break
    case 'merchant_monthly_report':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break
    case 'merchant_fca_report':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break
    case 'merchant_follow_up':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break
    case 'merchant_leads_sale':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break
    case 'merchant_leads_campaign':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break
    case 'merchant_leads_fee':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break
    case 'merchant_compliance_review':
      if (!hasEvery('merchants')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Merchant.'
        )
      }
      break

    case 'payout_frozen':
      if (!hasEvery('offers')) {
        linkingErrors.push(
          'This type of ticket should be linked to a Transaction.'
        )
      }
      break

    default:
      break
  }

  return linkingErrors.length ? { links: linkingErrors } : null
}
